import { getCalendarProviderAccountForType } from '../selectors/calendarProviderAccountsSelectors';
import { updateCalendarSubscriptionsOfCalendarProvider as updateCalendarSubscriptionsOfCalendarProviderService } from '../services/updateCalendarSubscriptionsOfCalendarProvider';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import {
    updateCalendarSubscriptionsOfCalendarProvider,
    calendarSubscriptionsUpdatedOfCalendarProvider,
    errorWhenUpdatingCalendarSubscriptionsOfCalendarProvider,
} from '../actions/publicActions';
import { localLieUpdateToCalendarSubscriptions } from '../actions/internalActions';

orchestrator(updateCalendarSubscriptionsOfCalendarProvider, async actionMessage => {
    const { providerType, subscribeRequests, unsubscribeCalendarIds } = actionMessage;
    const calendarProviderAccount = getCalendarProviderAccountForType(providerType);
    const subscribeCalendarIds = subscribeRequests.map(req => req.calendarId);

    if (!calendarProviderAccount) {
        trace.warn(`No calendar provider account found for type ${providerType}`);
        errorWhenUpdatingCalendarSubscriptionsOfCalendarProvider(
            providerType,
            subscribeCalendarIds,
            unsubscribeCalendarIds
        );
        return;
    }

    if (subscribeRequests.length > 0 || unsubscribeCalendarIds.length > 0) {
        try {
            await updateCalendarSubscriptionsOfCalendarProviderService(
                providerType,
                calendarProviderAccount.id,
                subscribeRequests,
                unsubscribeCalendarIds
            );
        } catch (error) {
            trace.warn(
                `Error when updating calendar subscriptions: Error: ${error.toString()}; CalendarsNotSubscribed: ${subscribeCalendarIds.join(
                    ','
                )}; CalendarsNotUnsbuscribed: ${unsubscribeCalendarIds.join(',')}`
            );

            errorWhenUpdatingCalendarSubscriptionsOfCalendarProvider(
                providerType,
                subscribeCalendarIds,
                unsubscribeCalendarIds
            );
            return;
        }
    }

    // As the operation was successful so we locally apply the changes
    localLieUpdateToCalendarSubscriptions(
        providerType,
        calendarProviderAccount.id,
        subscribeRequests,
        unsubscribeCalendarIds
    );

    calendarSubscriptionsUpdatedOfCalendarProvider(
        providerType,
        subscribeCalendarIds,
        unsubscribeCalendarIds
    );
});
